<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  title?: string
  showBack?: boolean
}>(), {
  showBack: true
})

const goBack = () => {
  const lastSearch = localStorage.getItem('lastDiamondSearch')
  if (lastSearch) {
    window.location.href = lastSearch
  } else {
    // The main search is the current url without the certificates id
    let path = window.location.pathname
    if (path.endsWith('/')) {
      path = path.slice(0, -1)
    }
    const parts = path.split('/')
    parts.pop()
    window.location.href = parts.join('/') + '/'
  }
}

const backLabel = computed(() => {
  const lastSearch = localStorage.getItem('lastDiamondSearch')
  return lastSearch 
    ? 'components.diamonds.details.DiamondDetailsNav.backToSearch' 
    : 'components.diamonds.details.DiamondDetailsNav.backToOverview'
})
</script>

<template>
  <nav class="bg-white border-b border-gray-100 py-3 mb-6">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between">
        <div v-if="showBack" class="flex items-center w-[160px]">
          <button 

            @click="goBack"
            class="flex items-center text-sm text-gray-500 hover:text-brand-main transition-colors duration-200"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              class="h-4 w-4 mr-2" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                stroke-linecap="round" 
                stroke-linejoin="round" 
                stroke-width="2" 
                d="M10 19l-7-7m0 0l7-7m-7 7h18" 
              />
            </svg>
            {{ $t(backLabel) }}
          </button>
        </div>
        <div v-if="title" class="flex-grow text-center">
          <h1 class="text-xl font-serif text-gray-800 tracking-widest uppercase">
            {{ title }}
          </h1>
        </div>
        <!-- Spacer to keep title centered when back button is present -->
        <div v-if="showBack" class="w-[160px]"></div>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.text-brand-main {
  color: #a99d8b;
}
</style>
